import { useUser } from "@/contexts/UserContext";
import { StoryRunConifg } from "@/types/StoriesTypes";
import { getFlattenedRunConfigOptionsBySku, getRunConfigOptionsBySku } from "./product.service";
import { MarketRunConfigOptions, ProductRunConfigOptions } from "@/types/RunConfigOptions";
import { DEMOGRAPHIC_DIMENSIONS_DEFAULT } from "@/constants/report.constants";

export const useStoryRunService = () => {
    const { defaultRunConfig } = useUser();
    return {
        
        getStoryDefaultRunConfigBySku(sku?: string | null): Partial<StoryRunConifg> {
            const includedRunConfigValues: Partial<StoryRunConifg> = {};

            if (!sku) return includedRunConfigValues;

            const runConfigOptions = getRunConfigOptionsBySku(sku);
            const flattenedConfigOptions = getFlattenedRunConfigOptionsBySku(sku);
            const dflt =
                flattenedConfigOptions.datatype === 'omni'
                    ? defaultRunConfig?.omni
                    : flattenedConfigOptions.datatype === 'osh'
                    ? defaultRunConfig?.osh
                    : flattenedConfigOptions.datatype === 'cps'
                    ? defaultRunConfig?.cps
                    : defaultRunConfig?.rms;

            const includeTimePeriod =
                flattenedConfigOptions.datatype !== 'omni' &&
                Boolean(runConfigOptions.find(({ type }) => type === 'time_period'));
            const hasMarketRunConfigOptions = Boolean(runConfigOptions?.find(({ type }) => type === 'market'));
            const defaultBrandsLength = dflt?.brands?.length ?? 0;

            includedRunConfigValues.datatype = flattenedConfigOptions.datatype; // todo: check to see if this actually needed. keeping for now

            if ((flattenedConfigOptions as ProductRunConfigOptions).includeBrands) {
                const maxBrands = (flattenedConfigOptions as ProductRunConfigOptions)?.maxBrands ?? 0;
                includedRunConfigValues.brands =
                    ((flattenedConfigOptions as ProductRunConfigOptions).maxBrands && maxBrands < defaultBrandsLength)
                        ? []
                        : dflt?.brands;
            }
            if ((flattenedConfigOptions as ProductRunConfigOptions).includeCategories) {
                includedRunConfigValues.categories =  Array.isArray(dflt?.categories)? dflt?.categories: [];
            }
            if ((flattenedConfigOptions as ProductRunConfigOptions).includeCharacteristics) {
                includedRunConfigValues.characteristics = dflt?.characteristics;
            }
            if ((flattenedConfigOptions as ProductRunConfigOptions).includeFocusBrands) {
                const maxFocusBrands = (flattenedConfigOptions as ProductRunConfigOptions)?.maxFocusBrands ?? 0;
                includedRunConfigValues.focusBrands =
                   ((flattenedConfigOptions as ProductRunConfigOptions).maxFocusBrands &&
                    maxFocusBrands < defaultBrandsLength)
                        ? []
                        : dflt?.brands;
            }

            if ((flattenedConfigOptions as ProductRunConfigOptions).includeDemographicDimensions) {
                includedRunConfigValues.demographicDimensions = dflt?.demographicDimensions ?? DEMOGRAPHIC_DIMENSIONS_DEFAULT;
            }

            if ((flattenedConfigOptions as ProductRunConfigOptions).includeProductSubcategory) {
                includedRunConfigValues.subcategories = dflt?.subcategories;
            }

            // markets only apply to rms reports for now.
            // todo: consider adding support different market types
            if (
                hasMarketRunConfigOptions &&
                !(flattenedConfigOptions as MarketRunConfigOptions).requireRemainingMarket
            ) {                
                includedRunConfigValues.markets = dflt?.markets;
            }

            // time periods don't apply to omni reports b/c they use a different format
            // todo: consider adding support multiple time period types
            if (includeTimePeriod && dflt?.timePeriod) {
                includedRunConfigValues.timePeriod = dflt?.timePeriod;
            }

            return includedRunConfigValues;
        },
    }
}